import { keys as lodashKeys } from 'lodash';

/* global window */

export default class UrlHelper {
    static getQueryParamValue(key, url = window.location.search) {
        const queryParams = url.substring(1).split('&');
        const param = queryParams.find(p => p.indexOf(`${key}=`) === 0);
        if (param && param.indexOf('=') !== -1) {
            return decodeURI(param.split('=')[1]);
        }
        return null;
    }

    static generateQueryString(params) {
        const keys = lodashKeys(params);
        return keys.map(name => `${name}=${encodeURIComponent(params[name])}`);
    }

    static isRunningOnDeveloperMachine() {
        return /^https?:\/\/localhost/.test(window.location);
    }
}



// WEBPACK FOOTER //
// ./helpers/url-helper.js